import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Button } from '@navikt/ds-react';
const BackToTopButton = () => {
  const $ = _c(4);
  const [offset, setOffset] = useState(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const setScrollOffset = function setScrollOffset() {
        setOffset(window.pageYOffset);
      };
      if (typeof window !== "undefined") {
        window.addEventListener("scroll", setScrollOffset);
      }
      return function cleanupListener() {
        if (typeof window !== "undefined") {
          window.removeEventListener("scroll", setScrollOffset);
        }
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== offset) {
    t2 = offset > 400 ? ReactDOM.createPortal(<Button style={{
      position: "fixed",
      bottom: 120,
      left: "calc(50% + 528px + 24px)",
      boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)"
    }} onClick={_temp}>Til toppen</Button>, document.body.getElementsByTagName("main")[0] || document.body) : null;
    $[2] = offset;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default BackToTopButton;
function _temp() {
  return window.scrollTo({
    top: 0,
    left: 0
  });
}